const lang = {
  props: {
    lang: {
      type: String,
      default: () => 'it'
    }
  }
}

export default lang
